<template>
    <section class="step-item step-groups">
        <section class="step-item__title">
            <h2>Radni</h2>
        </section>
        <section class="d-flex flex-column justify-content-center align-items-center py-3 px-3" style="background: #ffd9d9;">
            <span style="font-weight: bold">Uwaga!</span>
            <span>Jeśli potrzebujesz utworzyć więcej kont radnych niż jest dostępnych licencji, utwórz tyle kont na ile pozwala kreator nowej kadencji i przejdź dalej, a następnie, w wolnej chwili, skontaktuj się z nami w celu weryfikacji ilości licencji i utworzenia dodatkowych kont. Adres email: <a href="mailto:pomoc@mwc.pl">pomoc@mwc.pl</a>, telefon <b>61 666 19 77</b> wew. 1.</span>
        </section>
        <section class="step-item__body">
            <section class="step-item__body__item">
                <section class="toolbar">
                    <section class="info">
                        <p>Wprowadź listę radnych nowej kadencji - ilość dostępnych licencji <span class="limits" :class="{'limit-error': !canAddUser}">({{ $store.state.wizardNewCadence.usersList.length }} / {{$store.state.wizardNewCadence.availablelicences}})</span></p>
                    </section>
                    <section class="action">
                        <ButtonWithIcon :icon="'import-from-db'"
                                        :text="'Dodawanie masowe'"
                                        v-if="canAddUser"
                                        @click="$store.commit('setModalAddMultipleUserStatus', true)" />

                        <ButtonWithIcon :icon="'import-from-db'"
                                        :text="'Dodawanie masowe'"
                                        v-tooltip="'Przekroczono liczbę dozwolonych użytkowników. Dalszy import niemożliwy'"
                                        v-else
                                        :disabled="true" />
                    </section>
                </section>
                <section class="table-data">
                    <table class="table-bootstrap table-bootstrap-hover table-bootstrap-bordered table-bootstrap-striped align-middle">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Imię</th>
                                <th>Nazwisko</th>
                                <th>Grupa</th>
                                <th>Adres E-Mail</th>
                                <th>Telefon</th>
                                <th></th>
                            </tr>
                            <tr class="align-middle">
                                <td></td>
                                <td>
                                    <InputComponent ref="nameInputComponent"
                                                    v-model="$store.state.wizardNewCadence.userCreateModel.name"
                                                    :isError="errors.name.length > 0"
                                                    :errorTooltip="getFieldError(errors.name)"
                                                    type="text" />
                                </td>
                                <td>
                                    <InputComponent v-model="$store.state.wizardNewCadence.userCreateModel.surname"
                                                    :isError="errors.surname.length > 0"
                                                    :errorTooltip="getFieldError(errors.surname)"
                                                    type="text" />
                                </td>
                                <td>
                                    Radni
                                </td>
                                <td>
                                    <InputComponent v-model="$store.state.wizardNewCadence.userCreateModel.email"
                                                    :isError="errors.email.length > 0"
                                                    :errorTooltip="getFieldError(errors.email)"
                                                    type="email" />
                                </td>
                                <td>
                                    <InputComponent v-model="$store.state.wizardNewCadence.userCreateModel.phonenumber"
                                                    type="tel" />
                                </td>
                                <td>
                                    <ButtonWithIcon :icon="'add-list'"
                                                    :text="'Dodaj'"
                                                    v-if="canAddUser"
                                                    @click="addUser" />

                                    <ButtonWithIcon :icon="'add-list'"
                                                    :text="'Dodaj'"
                                                    :disabled="true"
                                                    v-tooltip="'Przekroczono liczbę dozwolonych użytkowników. Dodanie kolejnego użytkownika zablokowane.'"
                                                    v-else />
                                </td>
                            </tr>
                        </thead>
                        <TransitionGroup tag="tbody">
                            <tr v-for="(item, index) in $store.state.wizardNewCadence.usersList" :key="index">
                                <td>{{index + 1 }}</td>
                                <td>{{item.name}}</td>
                                <td>{{item.surname}}</td>
                                <td>
                                    Radni
                                    <!--<span class="group-name" v-for="(group, groupIndex) in item.selectedGroups" :key="groupIndex">
                                        {{ group.label }}
                                    </span>-->
                                </td>
                                <td>{{ item.email }}</td>
                                <td>{{ item.phonenumber }}</td>
                                <td>
                                    <ButtonWithIcon :icon="'bin'" :text="'Usuń'" class="btn-step-item btn-reverse" @click="removeUser(item)" />
                                </td>
                            </tr>
                        </TransitionGroup>
                    </table>
                </section>
            </section>
        </section>
        <section class="step-item__footer">
            <ButtonWithIcon :icon="'additional-arrow'" :text="'Wstecz'" class="btn-step-item btn-reverse" @click="movePrev" />
            <ButtonIconAppend :icon="'additional-arrow'" class="btn-step-item" @click="moveNext" v-if="canAddUser">
                Dalej
            </ButtonIconAppend>

            <ButtonIconAppend :icon="'additional-arrow'" class="btn-step-item" :disabled="true" v-tooltip="'Formularz zawiera błędy, lub przekroczono liczbę dostępnych licencji użytkowników.'" v-else>
                Dalej
            </ButtonIconAppend>
        </section>
        <Transition>
            <AddMultipleUsersModal v-if="$store.state.wizardNewCadence.modalAddMultipleUser"
                                   :availableGroups="availableGroups"
                                   @parsed-groups="parsedGroups" />
        </Transition>

    </section>
</template>
<script charset="utf-8">
    import wizardNewCadenceService from "../../../../services/wizard.new.cadence.service";
    import ButtonWithIcon from "../../../BasicControls/ButtonWithIcon.vue";
    import ButtonIconAppend from "../../../BasicControls/ButtonIconAppend.vue";
    import AddMultipleUsersModal from "../../../Shared/Users/Modals/AddMultipleUsersModal.vue";
    //import UserForm from "../components/UserForm.vue";
    //import SearchLabelComponent from "../../../BasicControls/SearchLabelComponent.vue"
    import InputComponent from "../../../BasicControls/InputComponent.vue"
    //import Multiselect from "@vueform/multiselect"
    import userService from "../../../../services/user.service";


    export default {
        name: "Step5Users",
        components: {
            ButtonWithIcon,
            ButtonIconAppend,
            InputComponent,
            //SearchLabelComponent,
            //Multiselect,
            AddMultipleUsersModal
        },
        data() {
            return {
                errors: {
                    name: [],
                    surname: [],
                    email: [],
                    selectedGroups: []
                }
            }
        },
        computed: {
            availableGroups() {
                //return this.$store.state.wizardNewCadence.selectedGroups;
                return this.$store.state.wizardNewCadence.availableGroups
                    .filter(item => item.isSessions === true && this.$store.state.wizardNewCadence.selectedGroups.includes(item.id))
                    .map(item => ({
                        value: item.id,
                        label: item.name
                    }))
            },
            canAddUser() {
                return this.$store.state.wizardNewCadence.usersList.length <= this.$store.state.wizardNewCadence.availablelicences;
            }
        },
        watch: {
            '$store.state.wizardNewCadence.userCreateModel': {
                deep: true,
                handler() {
                    //this.$store.state.wizardNewCadence.userCreateModel.login = `${this.toUnicode(this.$store.state.wizardNewCadence.userCreateModel.name)}.${this.toUnicode(this.$store.state.wizardNewCadence.userCreateModel.surname)}`

                    this.$store.state.wizardNewCadence.userCreateModel.login = this.getLogin(this.$store.state.wizardNewCadence.userCreateModel);
                }
            }
        },
        async mounted() {
            try {
                let response = await userService.getKidRid();
                if (response.status === 200) {
                    console.log(response.data);
                }
                this.$store.commit("setWizardNewCadenceBusyStatus", true);
                this.$store.commit("setWizardNewCadenceCurrentStep", 5);
                await this.internalFetchAvailableLicences();
            }
            finally {
                this.$store.commit("setWizardNewCadenceBusyStatus", false);
            }
        },
        methods: {
            async internalFetchAvailableLicences() {
                let response = await wizardNewCadenceService.getAvailableLicenses();
                if (response.status === 200)
                    this.$store.state.wizardNewCadence.availablelicences = response.data;

            },

            async moveNext() {
                try {
                    this.$store.commit("setWizardNewCadenceBusyStatus", true);
                    this.$store.commit("setWizardNewCadenceStepsDone", 5);
                    await this.$router.push({ name: "NewCadenceWizardsSteps", params: { "step": 6 } });
                    this.$store.commit("setWizardNewCadenceCurrentStep", 6);
                }
                catch {
                    this.$store.commit("setWizardNewCadenceBusyStatus", false);
                }
            },

            async movePrev() {
                try {
                    this.$store.commit("setWizardNewCadenceBusyStatus", true);
                    await this.$router.push({ name: "NewCadenceWizardsSteps", params: { "step": 4 } });
                    this.$store.commit("setWizardNewCadenceCurrentStep", 4);
                }
                catch {
                    this.$store.commit("setWizardNewCadenceBusyStatus", false);
                }
            },

            getLogin(obj) {
                if (obj === undefined || obj === null) {
                    return "";
                }

                return `${this.toUnicode(obj?.name ?? "")}.${this.toUnicode(obj?.surname ?? "")}`;
            },

            toUnicode(str) {
                const letters = ['ą', 'ć', 'ę', 'ł', 'ń', 'ó', 'ś', 'ź', 'ż'];
                const replacement = ['a', 'c', 'e', 'l', 'n', 'o', 's', 'z', 'z'];

                let result = str.toLocaleLowerCase().trim();

                for (let i = 0; i < letters.length; ++i) {
                    result = result.replaceAll(letters[i], replacement[i]);
                }

                return result;
            },

            cleanErrors() {
                this.errors.name = [];
                this.errors.surname = [];
                this.errors.email = [];
                this.errors.selectedGroups = []
            },

            addUser() {
                try {
                    this.cleanErrors();
                    if (!this.validateNewUser()) {
                        return;
                    }

                    this.$refs.nameInputComponent.$el.children[0].focus()
                    this.$store.commit('setWizardNewCadenceUsersList')
                }
                finally {
                    console.log("finally");
                }
            },

            validateNewUser() {
                let status = true;
                try {
                    if (this.$store.state.wizardNewCadence.userCreateModel.name === "") {
                        this.errors.name.push("Pole nie może być puste")
                        status = false;
                    }


                    if (this.$store.state.wizardNewCadence.userCreateModel.surname === "") {
                        this.errors.surname.push("Pole nie może być puste")
                        status = false;
                    }

                    if (this.$store.state.wizardNewCadence.userCreateModel.email !== "") {
                        if (this.validateEmail(this.$store.state.wizardNewCadence.userCreateModel.email) === false) {
                            this.errors.email.push("Adres E-Mail jest nie poprawny");
                            status = false;
                        }

                        let existEmail = this.$store.state.wizardNewCadence.usersList
                            .filter(item => item.email === this.$store.state.wizardNewCadence.userCreateModel.email);

                        if (existEmail.length > 0) {
                            this.errors.email.push("Adres E-Mail jest już zajęty");
                            status = false;
                        }
                    }

                    if (this.$store.state.wizardNewCadence.userCreateModel.name !== "" && this.$store.state.wizardNewCadence.userCreateModel.surname !== "") {
                        let anyUser = this.$store.state.wizardNewCadence.usersList
                            .filter(item => item.login === this.$store.state.wizardNewCadence.userCreateModel.login);

                        if (anyUser.length > 0) {
                            this.errors.name.push("Użytkownik już istnieje")
                            this.errors.surname.push("Użytkownik już istnieje")
                            status = false;
                        }
                    }

                    //if (this.$store.state.wizardNewCadence.userCreateModel.selectedGroups.length < 1) {
                    //    this.errors.selectedGroups.push("Proszę wybrać conajmniej jedną grupę");
                    //    status = false;
                    //}


                }
                catch (e) {
                    console.log(e, "ValidationFailed");
                }
                return status;
            },

            getFieldError(fieldError) {
                return fieldError.join('\n\r');
            },

            validateEmail(email) {
                const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

                return email.match(validRegex) !== null;
            },

            groupSelected() {
                if (this.$store.state.wizardNewCadence.userCreateModel.selectedGroups.length < 1) {
                    this.errors.selectedGroups.push("Proszę wybrać conajmniej jedną grupę");
                }
                else {
                    this.errors.selectedGroups = []
                }
            },
            removeUser(el) {
                this.$store.state.wizardNewCadence.usersList = this.$store.state.wizardNewCadence.usersList.filter(item => item.id !== el.id);
            },


            parsedGroups(data) {
                try {
                    let localData = data.map(item => {
                        let copy = { ...item }
                        copy.login = this.getLogin(copy);
                        return copy;
                    })
                    this.$store.state.wizardNewCadence.usersList = this.$store.state.wizardNewCadence.usersList.concat(localData);
                }
                catch (e) {
                    console.log(e);
                }
            }

        }
    }
</script>
<style lang="scss">
    @import "@/assets/scss/wizard-generic-step.scss";

    .table-data {
        .groups {
            display: flex;
            flex-direction: column;
        }
        /* .multiselect {
            .multiselect-wrapper {
                padding: 8.5px 0px;
            }
        }

        .has-error {
            border-color: red;

            .multiselect-wrapper {
                padding: 8.5px 0px;

                &::before {
                    top: 50%;
                    right: 15px;
                    transform: translate(-50%, -50%);
                    content: "";
                    position: absolute;
                    width: 24px;
                    height: 24px;
                    z-index: 2;
                    background-image: url('@/assets/icons/components/error-alert.svg');
                }
            }
        }*/
    }

    .toolbar {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .limits {
        font-weight: bold;

    }
    .limit-error {
        color: red;
    }
</style>
